module.exports = __webpack_public_path__ + "img/billPayment.1bed3bc0.svg";